// The reference an observability bug report is known by in Slack, GitHub and the dashboard.
// Derived from the report id so the reporter can quote it the moment they submit.
export const formatBugReference = (id: string): string => `BUG-${(id ?? '').replace(/-/g, '').slice(0, 8).toUpperCase()}`;
